import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchCompliance(action) {
  const { filtersString } = action.payload;
  try {
    const response = yield call(API.fetchOverallCompliance, {
      filtersString
    });
    yield put(actions.fetchComplianceSuccess(response.data));
  } catch (error) {
    yield put(actions.fetchComplianceFailure(error));
  }
}

export function* overallComplianceSaga() {
  yield takeLatest(actions.fetchCompliance.type, handleFetchCompliance);
}